import moment from 'moment';

export default () => (time) => moment(time, 'h:mm').format('h:mm a');
